import React, { PropTypes } from 'react';
import cx from './BlockHeader.scss';
import BlockTitle from './BlockTitle';

const values = __('goal.periods');

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class BlockHeader extends React.Component {

	static propTypes = {
		currentItem: PropTypes.oneOf(Object.keys(values)).isRequired,
		onNav: PropTypes.func.isRequired,
		children: PropTypes.any,
	};

	render() {
		const { children, currentItem, onNav } = this.props;

		return (
			<header className={cx('main')}>
				<BlockTitle>
					{children}
				</BlockTitle>

				<ul className={cx('menu')}>
					{Object.keys(values).map(key =>
						<li key={key} onClick={() => onNav(key)} className={cx('item', { active: currentItem === key })}>
							<a>{values[key]}</a>
						</li>
					)}
				</ul>
			</header>
		);
	}

}



// WEBPACK FOOTER //
// ./src/react/elements/GoalsPage/BlockHeader.js